import { render, staticRenderFns } from "./rotate.vue?vue&type=template&id=99816f38"
import script from "./rotate.vue?vue&type=script&lang=js"
export * from "./rotate.vue?vue&type=script&lang=js"
import style0 from "./rotate.vue?vue&type=style&index=0&id=99816f38&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports